import { LESSON_TYPES } from './lessonTypes';

export const LECTURE_LESSON_TYPES = [
  LESSON_TYPES.liveLecture,
  LESSON_TYPES.assignment,
  LESSON_TYPES.homework,
  LESSON_TYPES.preRead,
];
